module.exports = __webpack_public_path__ + "static/media/rgb2.a4dd5d2a.png";